import { ContentService } from 'src/app/services/content/content.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController, Platform } from '@ionic/angular';
import { CredentialsService } from 'src/app/services/credentials/credentials.service';
import { LanguagesService } from 'src/app/services/languagesService/languages.service';
import { TagsService } from 'src/app/services/tags/tags.service';
import { StorageService } from "src/app/services/storage/storage.service";
import { environment } from "src/environments/environment";
import { RemoteConfigService } from 'src/app/services/remote-config/remote-config.service';
import { RouterService } from 'src/app/services/router/router.service';
import { ImageComponent } from 'src/app/components/image/image.component';
import { ChallengesService } from 'src/app/services/challenges/challenges.service';
import { from } from 'rxjs';
@Component({
  selector: 'app-challenges-detail',
  templateUrl: './challenges-detail.page.html',
  styleUrls: ['./challenges-detail.page.scss'],
})
export class ChallengesDetailPage implements OnInit {

  public id: string;
  public type: string;
  token: any;
  appId: any;
  isStrapi = true;
  document: any = { data: null, error: null, status: 'pending' };
  data;
  
  constructor(
    private router: Router,
    public languageService: LanguagesService,
    private route: ActivatedRoute,
    private tagsService: TagsService,
    private storageService: StorageService,
    private contentService: ContentService,
    private platform: Platform,
    private remoteConfig: RemoteConfigService,
    private credentialsService: CredentialsService,
    private routerService: RouterService,
    private modalController: ModalController,
    private challengesService: ChallengesService) {
    this.id = this.route.snapshot.paramMap.get('id');
    this.type = this.route.snapshot.paramMap.get('type');
  }

  async ngOnInit() {
    this.remoteConfig.getIsStrapi().subscribe((res) => {
      this.isStrapi = res;
    });
    this.getCmsChallengeId();
    this.token = await this.storageService.get("gnx-token");
    this.appId = environment.gluky.apikey;
  }

  get getTextsIUPageChallenges() {
    return this.languageService.textsIU.page_challenges_detail;
  }

  goTo(route){
    this.router.navigateByUrl(route);
  }

  async getCmsChallengeId() {
    this.document = { data: null, error: null, status: 'pending' };
    
    try {
      // Obtener el challenge ID utilizando await   
      const info = await this.contentService.getChallengeId(this.id);
      // Obtener la referencia del usuario en Firestore   /ChallengeUsers/${userId}/Challenges
      const usrDocRef = this.challengesService.getChallengeUser(this.id);
      // Obtener el documento de usuario y esperar a que se resuelva
      const usrDocSnapshot: any = await usrDocRef.get().toPromise();
      // Obtener el estado del documento de usuario
      const status = usrDocSnapshot.exists && usrDocSnapshot.get('status') ? usrDocSnapshot.get('status') : 'retry';
      // Transformar los items utilizando el estado obtenido
      console.log("___info",info);
      const itemsArray = info.map( (item) =>  this.transformItem(item, status));
//esto se remplazaria en caso de que this.transformItem devovlviera una promesa 
      // const itemsArray = await Promise.all(
      //   info.map(async (item) => {
      //     return await this.transformItem(item, status);
      //   })
      // );

      this.data = itemsArray[0];
      console.log('___this.data',this.data);
      console.log('___itemsArray',itemsArray);

      // Actualizar el estado del documento
      this.document = { status: 'resolved', data: this.data, error: null };
    } catch (error) {
      // Manejar errores y actualizar el estado del documento
      console.error(error);
      this.document = { status: 'error', data: null, error };
    }
  }
  
  private transformItem(item, status): any {
    item.Banner.url = this.contentService.updateImageUrl(item.Banner, 't_content-detail');
    return {
      bannerImage: this.contentService.updateImageUrl(item.Banner, 't_content-detail'),
      fields: item.Responses_fields || [],
      description: (item.Content && item.Content.Description) ? item.Content.Description : '',
      image: item.Image,
      programId: item.gn_fields && item.gn_fields.programs ? item.gn_fields.programs : '',
      status: status,
      userStatus: status,
      subTitle: item.Subtitle || '',
      title: item.Title || '',
      banner: item.Banner || {},
      content: item.Contents
    };
  }


  async zoomImg(imgDetail){
    const img = imgDetail.detail;
    const image = img.url;
    if(img.link && img.link.Type){
      if (img.link.Type == "EXTERNAL" || img.link.Type == "url") {
        window.open(
          img.link.linkId,
          '_blank'
        );
      } else {
        this.routerService.redirect(img.link.linkId)
        return;
      }
    }
    
    const modal = await this.modalController.create({
      component: ImageComponent,
      id: "modal-img",
      componentProps: {
        'image': image
      },
      backdropDismiss: true
    });
    return await modal.present();
  }

  public formNavigate(value?) {
    value = value ? value : { id: this.id, type: 'challenge'}
    const { id, type } = value;
    if (this.platform.is("desktop")) {
      this.router.navigate(['app', 'challenges', 'form', type, id]);
    } else {
      this.router.navigate(['challenges', 'form', type, id]);
    }
  }

  getCredentialsChallenges = async () => {
    return await this.credentialsService.challengesStrapi();
  };

  getCredentialsChallengesPrefix = async () => {
    // return await this.contentService.getSignature();
  };

}
